import React from "react";
import { Collapse } from "antd";
import { SettingOutlined } from "@ant-design/icons";

const { Panel } = Collapse;

const Setting = () => {
  return (
    <Collapse>
      <Panel header="Settings" key="1" extra={<SettingOutlined />}>
     Upcoming
      </Panel>
    </Collapse>
  );
};

export default Setting;
